import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";
import {SCENE_FRAMES} from "ui/config";

/**
 * Transform layer: make resize for each frame
 */
export default class CanvasScale extends AbstractCanvasTransformTool {
	/**
	 * @param {number} scaleFrom
	 * @param {number} scaleTo
	 * @param {boolean} xAxis
	 * @param {boolean} yAxis
	 * @param {boolean} smooth
	 */
	constructor(scaleFrom, scaleTo, xAxis, yAxis, smooth) {
		super();
		this._scaleFrom = scaleFrom;
		this._scaleTo = scaleTo;
		this._xAxis = xAxis;
		this._yAxis = yAxis;
		this._smooth = smooth;
		this._scaleByFrames = [];
	}

	/**
	 * @inheritDoc
	 */
	_isNeedKeyframesForSelection(fromFrame, toFrame) {
		return fromFrame !== toFrame && this._scaleFrom !== this._scaleTo;
	}

	/**
	 * @inheritDoc
	 */
	_isAntiAliasing() {
		return this._smooth === true;
	}

	/**
	 * @inheritDoc
	 */
	async _prepare(layer, fromFrame, toFrame) {
		const len = toFrame - fromFrame;
		let scale, scaleStep;

		this._scaleByFrames = new Array(SCENE_FRAMES).fill(0);

		if (len === 0) {
			scaleStep = 0;
			scale = this._scaleFrom;
		} else if (this._scaleFrom === this._scaleTo) {
			scaleStep = 0;
			scale = this._scaleFrom;
		} else {
			scaleStep = (this._scaleTo - this._scaleFrom) / len;
			scale = this._scaleFrom;
		}

		for (let i = fromFrame; i <= toFrame; i++) {
			this._scaleByFrames[i] = scale;
			scale += scaleStep;
		}
	}

	/**
	 * @inheritDoc
	 */
	_transformImage(ctx, mat, frameIndex) {
		mat.scale(
			this._xAxis ? this._scaleByFrames[frameIndex] : 1,
			this._yAxis ? this._scaleByFrames[frameIndex] : 1
		);
	}
}
